(function() {
  const STORAGE_KEY = 'cos-wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: list } }));
    updateAllButtons();
    updateCount();
  }

  function toggleItem(handle) {
    const list = getWishlist();
    const index = list.indexOf(handle);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(handle);
    }
    saveWishlist(list);
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist-handle]').forEach(btn => {
      const handle = btn.dataset.wishlistHandle;
      btn.classList.toggle('wishlist-button--active', isInWishlist(handle));
      btn.setAttribute('aria-pressed', isInWishlist(handle));
    });
  }

  function updateCount() {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-handle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggleItem(btn.dataset.wishlistHandle);
  });

  document.addEventListener('DOMContentLoaded', () => {
    updateAllButtons();
    updateCount();
  });

  window.CosWishlist = { getWishlist, isInWishlist, toggleItem };
})();
